import {ProductModel} from "../../Models/ProductModel";

export const pdv144Products: ProductModel[] = [
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 105,
            name: "Pepsi",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Soft"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 116,
            name: "Bi\u00e8re Arena",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Bi\u00e8re avec alcool"
                },
                {
                    name: "Alcool"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                },
                {
                    name: "Boisson Soft ou Bi\u00e8re ou Vin"
                }
            ],
            tva: {
                id: 1,
                name: "20%",
                rate: 20
            }
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 5,
                    name: "10%",
                    rate: 10,
                    rateTotal: 10,
                    type: "percent"
                }
            }
        ],
        stockAvailable: 2
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 122,
            name: "Chips Lays 45g",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Snack"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 5
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 118,
            name: "Sandwich poulet",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Alimentaire"
                },
                {
                    name: "Sandwich"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [],
        stockAvailable: 4
    },
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 107,
            name: "Pepsi max",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Soft"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2023-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 3
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 117,
            name: "Bi\u00e8re kro",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Bi\u00e8re avec alcool"
                },
                {
                    name: "Alcool"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                },
                {
                    name: "Boisson Soft ou Bi\u00e8re ou Vin"
                }
            ],
            tva: {
                id: 1,
                name: "20%",
                rate: 20
            }
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 5,
                    name: "10%",
                    rate: 10,
                    rateTotal: 10,
                    type: "percent"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 123,
            name: "kinder bueno",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Snack"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 119,
            name: "Sandwich poisson",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Alimentaire"
                },
                {
                    name: "Sandwich"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [],
        stockAvailable: 0
    },
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 108,
            name: "Pepsi cerise",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Soft"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 115,
            name: "Bi\u00e8re heineken",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Bi\u00e8re avec alcool"
                },
                {
                    name: "Alcool"
                },
                {
                    name: "Boisson tout type"
                },
                {
                    name: "Boisson soft ou bi\u00e8re"
                },
                {
                    name: "Boisson Soft ou Bi\u00e8re ou Vin"
                }
            ],
            tva: {
                id: 1,
                name: "20%",
                rate: 20
            }
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 5,
                    name: "10%",
                    rate: 10,
                    rateTotal: 10,
                    type: "percent"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 124,
            name: "kinder country",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Snack"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: {
                    id: 4,
                    name: "2=3",
                    rate: 2,
                    rateTotal: 3,
                    type: "quantity"
                }
            }
        ],
        stockAvailable: 0
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 120,
            name: "Sandwich boeuf",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                {
                    name: "Alimentaire"
                },
                {
                    name: "Sandwich"
                }
            ],
            tva: {
                id: 1,
                name: "10%",
                rate: 10
            }
        },
        automaticDiscounts: [],
        stockAvailable: 0
    }
]
